
define('tmpl!core/templates/webidl-contiguous/implements.html', ['deps/handlebars'], function (hb) { return hb.compile('<span class=\'idlImplements\'>{{extAttr obj indent\n}}{{idn indent}}<a>{{obj.target}}</a> implements <a>{{obj.implements}}</a>;</span>');});

